<template>
    <f7-page name="beneficiary-details" @page:beforein="showHideInput2" @page:afterin="afterin">
        <f7-navbar class="view-mobile no-border">
            <f7-nav-left class="back-button">
                <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
            </f7-nav-left>
            <f7-nav-right></f7-nav-right>
        </f7-navbar>

        <div class="block">
            <transition name="fade">
                <f7-card
                    :title  ="alertCard.title"
                    class   ="alert alert-danger margin"
                    style   ="max-height:54px"
                    v-show  ="alertCard.show"
                >
                    <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
                </f7-card>
            </transition>

            <f7-row class="wandr-paragraph-1 vertical-margin">{{$t('beneficiary-recipient-details')}}</f7-row>

            <ModifyBeneficiarySelectCountry />

            <BeneficiaryBillPayment v-if="showFormSet.billPayment"
                @changeBillCorp="changeBillCorp"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryBasic1
                @changeIdType="changeIdType"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <div v-if="showFormSet.bankTransfer">
                <BeneficiaryBTBeneficiaryType
                    @changeBeneficiaryType="changeBeneficiaryType"
                />

                <ModifyBeneficiaryBTBankName />

                <ModifyBeneficiaryBTBanKBranch />

                <BeneficiaryBTDetails
                    @validateInput="validateInput"
                    @setInput="setInput"
                />

                <ModifyBeneficiaryBTIfsc />
            </div>

            <BeneficiaryCollection v-if="showFormSet.collection"
                :key="forceRerenderKey.componentCollectionKey"
                @changeCollectionAgent="changeCollectionAgent"
                @changeCollectionPoint="changeCollectionPoint"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryProvinceDetails v-if="showFormSet.provinceDetails"
                :key="forceRerenderKey.componentProvinceDetailsKey"
                @changeProvince="changeProvince"
                @changeCity="changeCity"
                @changeStreet="changeStreet"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryDoorToDoor v-if="showFormSet.doorToDoor || showFormSet.provinceDetails"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryBasic2
                @changePhilGovMemberType="changePhilGovMemberType"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <div v-if="showFormSet.kaasiDetails">
                <BeneficiaryAudBtAddress
                    @validateInput="validateInput"
                    @setInput="setInput"
                />
            </div>

            <BeneficiaryAudBtState v-if="showFormInput.kaasiDetails.state"
                :key="forceRerenderKey.componentAudBtStateKey"
                @changeProvince="changeProvince"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryAudBtSuburb v-if="showFormSet.kaasiDetails"
                :key="forceRerenderKey.componentAudBtSuburbKey"
                @changeCity="changeCity"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <div v-if="showFormSet.kaasiDetails">
                <BeneficiaryAudBtPoscode
                    @validateInput="validateInput"
                    @setInput="setInput"
                />
            </div>

            <BeneficiaryAudBtReceiverType v-if="showFormInput.kaasiDetails.radioButton"
                @changeBeneficiaryType="changeBeneficiaryType"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryAudBtBusiness v-if="showFormInput.kaasiDetails.auBusiness"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryNzBtBusiness v-if="showFormInput.kaasiDetails.nzBusiness"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryPaymentPurpose v-if="isShowPaymentPurpose"
                :key="forceRerenderKey.componentPaymentPurposeKey"
                @changePaymentPurpose="changePaymentPurpose"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryHomePhone v-if="isShowPhone"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryMobilePhone v-if="isShowPhone"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryEmail
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryAddressDetails
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <f7-button @click="modifyRecipient" large fill :disabled="isFormInputValid ? false : true" :class="( beneficiary.statusId == 0 || beneficiary.statusId == 1 ) ? 'view-desktop' : 'view-desktop mb-5'">
                {{$t('beneficiary-btn-save')}}
            </f7-button>
            <f7-button v-if="beneficiary.statusId == 0 || beneficiary.statusId == 1" @click="openConfirmDialog" large fill class="view-desktop mt-3 mb-5 color-gray6 text-color-red">
                {{$t('beneficiary-btn-delete')}}
            </f7-button>
        </div>

        <f7-toolbar position="bottom" no-hairline class="toolbar-with-stacked-button view-mobile">
            <f7-button @click="modifyRecipient" large fill :disabled="isFormInputValid ? false : true">
                {{$t('beneficiary-btn-save')}}
            </f7-button>
            <f7-button v-if="beneficiary.statusId == 0 || beneficiary.statusId == 1" @click="openConfirmDialog" large fill class="color-gray6 text-color-red">
                {{$t('beneficiary-btn-delete')}}
            </f7-button>
        </f7-toolbar>

        <f7-sheet class="wandr-sheet-modal" :opened="daValidation.showSheet" @sheet:closed="daValidation.showSheet = false">
            <f7-page-content>
                <f7-block>
                    <f7-row class="mt-lg mb-md fs-18 fw-semibold text-color-black" id="daTitleLbl"></f7-row>
                    <p class="fs-14 fw-medium no-margin mb-xl text-color-gray" id="daDescLbl">-</p>
                    <div class="bg-color-gray3 card-20 mb-lg" style="border-radius: 10px">
                        <div class="text-color-gray fs-14 fw-medium">{{$t('beneficiary-da-current-name')}}</div>
                        <div class="regSuccess text-color-black fs-14 fw-bold" id="currentValue">-</div>
                        <div class="text-color-gray fs-14 fw-medium mt-md">{{$t('beneficiary-da-proposed-name')}}</div>
                        <div class="regSuccess text-color-black fs-14 fw-bold" id="proposedValue">-</div>
                    </div>
                    <f7-row>
                        <f7-col>
                            <f7-button large fill class="color-gray3 text-color-green" @click="validateDAChoice(1)" >{{$t('general-btn-no')}}</f7-button>
                        </f7-col>
                        <f7-col>
                            <f7-button large fill @click="validateDAChoice(2)">{{$t('general-btn-yes')}}</f7-button>
                        </f7-col>
                    </f7-row>
                </f7-block>
            </f7-page-content>
        </f7-sheet>
    </f7-page>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import store from '../../store';
    import addressDialogMixin from '../../plugins/address-dialog-mixin.js';

    export default {
        // DR-1845 code-inspection fix (Major) - showAddressRequiredAlert()/
        // confirmProceedWithoutAddress() were duplicated verbatim here and in
        // new-beneficiary-details.vue; now shared via this mixin (see its own
        // comment for the full rationale).
        mixins: [addressDialogMixin],
        mounted() {
            // Required for everypage. Toggle desktop-view footer.
            this.toggleFooterVisibility(false)
            this.$f7.$('.page-content').on('scroll', (e) => {
                this.toggleFooterVisibility(e.target)
            })

            this.showAlert(false);
            this.loadBeneficiaryDetails();
            this.init();
        },
        data() {
            return {
                beneficiary            : [],
                isShowPaymentPurpose   : true,
                isShowPhone            : false
            }
        },
        components: {
            ModifyBeneficiarySelectCountry: () => import('../../components/beneficiary-edit-select-country.vue'),
            BeneficiaryBillPayment        : () => import('../../components/beneficiary-bill-payment.vue'),
            BeneficiaryBasic1             : () => import('../../components/beneficiary-basic-1.vue'),
            BeneficiaryBasic2             : () => import('../../components/beneficiary-basic-2.vue'),
            BeneficiaryBTBeneficiaryType  : () => import('../../components/beneficiary-bt-beneficiary-type.vue'),
            ModifyBeneficiaryBTBankName   : () => import('../../components/beneficiary-edit-bt-bank-name.vue'),
            ModifyBeneficiaryBTBanKBranch : () => import('../../components/beneficiary-edit-bt-bank-branch.vue'),
            BeneficiaryBTDetails          : () => import('../../components/beneficiary-bt-details.vue'),
            ModifyBeneficiaryBTIfsc       : () => import('../../components/beneficiary-edit-bt-ifsc-code.vue'),
            BeneficiaryCollection         : () => import('../../components/beneficiary-collection.vue'),
            BeneficiaryProvinceDetails    : () => import('../../components/beneficiary-province-details.vue'),
            BeneficiaryDoorToDoor         : () => import('../../components/beneficiary-door-to-door.vue'),
            BeneficiaryAudBtAddress       : () => import('../../components/beneficiary-aud-bt-address.vue'),
            BeneficiaryAudBtPoscode       : () => import('../../components/beneficiary-aud-bt-postcode.vue'),
            BeneficiaryAudBtState         : () => import('../../components/beneficiary-aud-bt-state.vue'),
            BeneficiaryAudBtSuburb        : () => import('../../components/beneficiary-aud-bt-suburb.vue'),
            BeneficiaryAudBtReceiverType  : () => import('../../components/beneficiary-aud-bt-receiver-type.vue'),
            BeneficiaryAudBtBusiness      : () => import('../../components/beneficiary-aud-bt-business.vue'),
            BeneficiaryNzBtBusiness       : () => import('../../components/beneficiary-nz-bt-business.vue'),
            BeneficiaryPaymentPurpose     : () => import('../../components/beneficiary-payment-purpose.vue'),
            BeneficiaryHomePhone          : () => import('../../components/beneficiary-home-phone.vue'),
            BeneficiaryMobilePhone        : () => import('../../components/beneficiary-mobile-phone.vue'),
            BeneficiaryEmail              : () => import('../../components/beneficiary-email.vue'),
            BeneficiaryAddressDetails     : () => import('../../components/beneficiary-address-details.vue'),
        },
        computed: {
            ...mapGetters('auth', [
                'authenticating',
                'authenticationError',
                'authenticationErrorCode',
                'authenticationSuccess'
            ]),
            ...mapGetters('beneficiary', [
                'audAbn',
                'audAcn',
                'bankAccountNo',
                'bankAccountNoLabel',
                'bankBranch',
                'bankBranchId',
                'bankBranchList',
                'bankId',
                'bankList',
                'bankName',
                'bankNameLabel',
                'bankNamePlaceholder',
                'bankTypeId',
                'beneficiaryId',
                'beneficiaryName',
                'beneficiaryNameLabel',
                'beneficiaryType',
                'beneficiaryTypeId',
                'billCorporationId',
                'billCorporationList',
                'billCorporationName',
                'billerCode',
                'bsbCode',
                'city',
                'cityId',
                'cityList',
                'collectionAgent',
                'collectionAgentId',
                'collectionAgentList',
                'collectionPoint',
                'collectionPointId',
                'collectionPointList',
                'countryCodeList',
                'dateOfBirth',
                'deliveryMethod',
                'deliveryMethodId',
                'dmExternalName',
                'email',
                'emailLabel',
                'emailNotification',
                'homeCountryId',
                'homeCountryName',
                'homeIDD',
                'homeIDDCode',
                'homeNo',
                'hostCountryId',
                'hostCountryName',
                'iban',
                'identificationNo',
                'identificationNoLabel',
                'identificationType',
                'identificationTypeLabel',
                'idTypeList',
                'idTypeSelect',
                'idTypeSelectId',
                'ifscCode',
                'isbKashTx',
                'isCreateBeneficiary',
                'isDisplayErrorMsg',
                'isFormInputValid',
                'landmark',
                'locatingNote',
                'mobileIDD',
                'mobileIDDCode',
                'mobileNo',
                'mobileNoLabel',
                'nickname',
                'nzbn',
                'beneficiaryCountryId',
                'beneficiaryTownCity',
                'addressHardMandatory',
                'isAddressSectionInScope',
                'paymentPurpose',
                'paymentPurposeId',
                'paymentPurposeList',
                'paymentPurposeOther',
                'philGovMemberType',
                'philGovMemberTypeId',
                'philGovMemberTypeList',
                'postcode',
                'province',
                'provinceId',
                'provinceList',
                'radioErrorMsg',
                'refNo',
                'refNoLabel',
                'smsNotification',
                'sortCode',
                'street',
                'streetLabel',
                'swiftCode',
                'transactionTypeId',
                'transactionTypeList',
                'transactionTypeName',
                'validateInputState',
                'walletNo',
                'homeCountryIdd',
                'homeCountryList',
                'allCountryList',

                'forceRerenderKey',
                'showFormSet',
                'showFormInput',
                'alertCard',
                'daValidation',
            ])
        },
        on: {
            pageBeforeRemove() {
                const self = this;
                // Destroy all autocompletes
                self.autocompleteBillCorpDropdownSimple.destroy();
            },
        },
        methods: {
            ...mapActions('auth', ['login']),
            ...mapActions('beneficiary', [
                'displayBillPayment', 'displayBankTransfer', 'displayCollection', 'displayProvinceDetails', 'displayDoorToDoor',
                'displayKaasiDetails', 'displayBillerCode', 'displayBank', 'displayBankBranch', 'displayBeneficiaryType',
                'displayBsbCode', 'displayIban', 'displayIfscCode', 'displaySortCode', 'displaySwiftCode', 'displayCity',
                'displayPostcode', 'displayProvince', 'displayBeneficiaryName', 'displayNickname', 'displayIdType',
                'displayIdTypeSelect', 'displayIdNo', 'displayAccountNo', 'displayCnIdNo', 'displayDateOfBirth',
                'displayPhilGovFullName', 'displayPhilGovNickname', 'displayPhilGovMemberType', 'displayRefNo', 'displayAudBtState',
                'displayAudRadio', 'displayAudBusiness', 'displayNzBusiness', 'displayPaymentPurpose', 'displayPaymentPurposeOther',
                'displayHomeNo', 'displayMobileNo', 'displayEmail', 'changeStreetLabel', 'validateBillCorp', 'validateBeneficiaryName',
                'validateNickname', 'validateIdentificationType', 'validateIdTypeSelect', 'validateIdentificationNo',
                'validateBeneficiaryType', 'validateBank', 'validateBankBranch', 'validateBsbCode', 'validateIban',
                'validateSwiftCode', 'validateIfscCode', 'validateSortCode', 'validateCollectionAgent', 'validateCollectionPoint',
                'validateProvince', 'validateCity', 'validateStreet', 'validatePostcode', 'validateAccountNo', 'validateDOB',
                'validatePhilGovMemberType', 'validateRefNote', 'validateAbn', 'validateAcn', 'validateNzbn', 'validatePaymentPurpose',
                'validateHomeNo', 'validateMobileNo', 'validateEmail','validateLandmark',
                'validateBeneficiaryCountry', 'validateBeneficiaryTownCity',

                'setHomeCountryList',
                'loadAllCountryList',
                'setTransactionTypeList',
                'setTransactionType',
                'setBeneficiaryType',
                'setBankList',
                'setBank',
                'setBankBranch',
                'setBankBranchList',
                'setFormInputKaasiDetails',
                'setIdTypeList',
                'setIdTypeSelect',
                'setBankAccountNoLabel',
                'setEmailLabel',
                'setShowFormInputContactEmail',
                'setBankAccountNo',
                'setHostCountry',
                'setHomeCountry',
                'setPaymentPurpose',
                'setPaymentPurposeOther',
                'setPaymentPurposeList',
                'setPhilGovMemberTypeList',
                'setPhilGovMemberType',
                'setCityList',
                'setAllCityList',
                'setCity',
                'setStreetList',
                'setCollectionAgentList',
                'setCollectionAgent',
                'setCollectionPointList',
                'setCollectionPoint',
                'setBillCorp',
                'setBillerCode',
                'setBillCorporationList',
                'setCountryCodeList',
                'setProvinceList',
                'setProvince',
                'setStreet',
                'setStreetLabel',
                'setPostcode',
                'setLocatingNote',
                'setLandmark',
                'setRadioErrorMsg',
                'setHomeIDD',
                'setMobileIDD',
                'changePhilGovMemberType',
                'setBeneficiaryName',
                'setShowFormInputPaymentPurposeOther',
                'setIsDisplayErrorMsg',
                'changeHomePhoneCode',
                'changeMobilePhoneCode',
                'setIsFormInputValid',
                'setForceRerenderKey',
                'changeBank',
                'changeBankBranch',
                'setValidateInputState',
                'changeCollectionAgent',
                'changeCollectionPoint',
                'changeBeneficiaryType',
                'changeIdType',
                'changePaymentPurpose',
                'changeProvince',
                'changeCity',
                'changeBillCorp',
                'setIdentificationNo',
                'setIdentificationType',
                'setBsbCode',
                'setIban',
                'setSwiftCode',
                'setIfscCode',
                'setSortCode',
                'setDateOfBirth',
                'setNickname',
                'setRefNo',
                'setAudAbn',
                'setAudAcn',
                'setNzbn',
                'setBeneficiaryCountry',
                'setBeneficiaryTownCity',
                'setHomeNo',
                'setMobileNo',
                'setEmail',
                'setDeliveryMethod',
                'setBankTypeId',
                'setEmailNotification',
                'setSmsNotification',
                'setDmExternalName',
                'setIsCreateBeneficiary',
                'setWalletNo',
                'setHomeCountryList',
                'setHomeCountry',
                'setIsDropdown',
                'changeStreet',


                'resetFormData',
                'resetDataStore',
                'showHideInput2',
                'validateInput',
                'resetBeneficiaryState',
                'finalValidatePostcode',
                'finalValidatePaymentPurpose',
                'finalValidateHomePhone',
                'finalValidateMobilePhone',
                'loadCityList',
                'loadPostCity',
                'loadAddressConfig',
            ]),

            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },
            async loadBeneficiaryDetails() {
                const self        = this;
                self.showPreloader();

                // GET HOME COUNTRY LIST
                const homeCountryPromise     = await self.$api.beneficiary.getCountryList();
                self.setHomeCountryList(homeCountryPromise);

                const benePromise = await this.$api.beneficiary.getBeneficiaryDetail(self.beneficiaryId);
                self.beneficiary  = benePromise;

                // DR-1845 - destination country/delivery method must be set in the
                // store BEFORE resolving Beneficiary Country/Town-City below - both
                // isAddressSectionInScope (used to scope the default-country fallback)
                // and the address section's own mandatory-check depend on
                // homeCountryId already being current, not still 0 from initial state.
                let homeCountryIddTmp = "";
                Object.keys(self.homeCountryList).forEach(key => {
                    if(self.homeCountryList[key].id == self.beneficiary.homeCountryId) {
                        homeCountryIddTmp = self.homeCountryList[key].idd
                        return;
                    }
                })

                self.setHostCountry({id: self.beneficiary.originatingCountryId, name: self.beneficiary.originatingCountry});
                self.setHomeCountry({id: self.beneficiary.homeCountryId, idd: homeCountryIddTmp, name: self.beneficiary.address.country});
                self.setDeliveryMethod({id: self.beneficiary.deliveryMethodId, name: self.beneficiary.deliveryMethod});

                // DR-1845 code-inspection fix (Minor) - extracted into its own
                // method (see loadBeneficiaryAddress() below) instead of growing
                // this already-large function further.
                await self.loadBeneficiaryAddress();

                self.setBeneficiaryName(self.beneficiary.fullName);
                self.setNickname(self.beneficiary.dropDownDisplayName);
                self.setEmail(self.beneficiary.email);
                self.setEmailNotification(self.beneficiary.emailNotification);
                self.setHomeIDD({
                    id: self.beneficiary.phoneOperatorCountryId == 0 ? self.beneficiary.homeCountryId : self.beneficiary.phoneOperatorCountryId,
                    name: self.beneficiary.phoneOperatorCountryId == 0 ? self.beneficiary.address.country : self.beneficiary.phoneCountryIDDCode
                });
                self.setHomeNo(self.beneficiary.phone);
                self.setMobileIDD({
                    id: self.beneficiary.mobileOperatorCountryId == 0 ? self.beneficiary.homeCountryId : self.beneficiary.mobileOperatorCountryId,
                    name: self.beneficiary.mobileOperatorCountryId == 0 ? self.beneficiary.address.country : self.beneficiary.mobileCountryIDDCode
                });
                self.setMobileNo(self.beneficiary.mobile);
                self.setSmsNotification(self.beneficiary.SMSNotification);

                // 0 - BILL PAYMENT
                if(this.deliveryMethodId == 0) {
                    self.setBillCorp({id: self.beneficiary.bankId, name: self.beneficiary.bank});
                    self.setBillerCode(self.beneficiary.billerCode);
                }

                // 1 - BANK TRANSFER
                if(this.deliveryMethodId == 1) {
                    self.setBank({id: self.beneficiary.bankId, name: self.beneficiary.bank});
                    self.setBankTypeId(self.beneficiary.bankTypeId);
                    self.setBankBranch({id: self.beneficiary.bankBranchId, name: self.beneficiary.bankBranch});

                    // 13 - AUSTRALIA || 152 - NEW ZEALAND
                    if(self.homeCountryId == 13 || self.homeCountryId == 152) {
                        self.setBsbCode(self.beneficiary.bankBranch.substring(0, 7).replace("-", "").trim());
                    }
                    // 98 - INDIA
                    else if(self.homeCountryId == 98) {
                        // self.setIfscCode(self.beneficiary.bankBranch.substring(0, 11));
                        const branchName = self.beneficiary.bankBranch;
                        self.setIfscCode(branchName);
                        if (branchName.startsWith('00000000000') && self.beneficiary.bankNotes.includes('IFSC')) {
                            const bankNotes = self.beneficiary.bankNotes;
                            const splitNote = bankNotes.split(',');
                            let newIFSC = '';
                            let newBranch = '';
                            for (let x = 0 ; x < splitNote.length; x++){
                                if (splitNote[x].includes('IFSC Code:')){
                                    newIFSC = splitNote[x].replaceAll('IFSC Code:', '');
                                } else if (splitNote[x].includes('Branch name:')){
                                    newBranch = splitNote[x].replaceAll('Branch name:', '');
                                    newBranch = newBranch.replaceAll(';', ' ');
                                }
                            }
                            self.setIfscCode(newIFSC.trim() + " ," + newBranch.trim());
                        }
                    }
                    // 221 - UNITED KINGDOM || 238 - EUROPEAN UNION (EU)
                    else if(self.homeCountryId == 221 || self.homeCountryId == 238) {
                        // 221 - UNITED KINGDOM
                        if(self.homeCountryId == 221) {
                            self.setSortCode(self.beneficiary.bankBranchName);
                        }
                        // 238 - EUROPEAN UNION (EU)
                        else if(self.homeCountryId == 238) {
                            self.setSwiftCode(self.beneficiary.bankBranchName);
                        }

                        if(self.beneficiary.bankNotes != undefined) {
                            let bankNotes = self.beneficiary.bankNotes.replace(";Online Txn - IBAN :","");
                            let iban = bankNotes.substring(bankNotes.lastIndexOf(";") + 1);
                            self.setIban(iban.substring(iban.lastIndexOf(':') + 1));
                        }
                    }
                    // 253 - AMERICA
                    else if(self.homeCountryId == 253) {
                        self.setSwiftCode(self.beneficiary.bankBranchName);
                    }
                }

                // NOT 3 - COLLECTION && 4 - DOOR TO DOOR && 9 - UPI
                if(this.deliveryMethodId != 3 && this.deliveryMethodId != 4 && this.deliveryMethodId != 9) {
                    self.setBankAccountNo(self.beneficiary.bankAccountNo);

                    const walletNumber = self.beneficiary.homeCountryId == 167 ? self.beneficiary.bankAccountNo : self.beneficiary.bankAccountNo.substring(homeCountryIddTmp.length-1)
                    self.setWalletNo(walletNumber);
                }

                // 1 - BANK TRANSFER || 9 - UPI
                if(this.deliveryMethodId == 1 || this.deliveryMethodId == 9) {
                    self.setBeneficiaryType({id: self.beneficiary.beneficiaryTypeId, name: ''});

                    const additionalList = self.beneficiary.additionalFieldList
                    if(additionalList != undefined && additionalList.length > 0) {
                        Object.keys(additionalList).forEach(key => {
                            if(additionalList[key].fieldId == 1) { // ABN
                                self.setAudAbn(additionalList[key].fieldValue);
                            } else if(additionalList[key].fieldId == 2) { // ACN
                                self.setAudAcn(additionalList[key].fieldValue);
                            } else if(additionalList[key].fieldId == 5) { // DATE OF BIRTH
                                self.setDateOfBirth(additionalList[key].fieldValue);
                            } else if(additionalList[key].fieldId == 6) { // NZBN
                                self.setNzbn(additionalList[key].fieldValue);
                            } else if(additionalList[key].fieldId == 7) { // VPA
                                self.setBankAccountNo(additionalList[key].fieldValue);
                            }
                        })
                    }
                }

                // 3 - COLLECTION
                if(this.deliveryMethodId == 3) {
                    self.setCollectionAgent({id: self.beneficiary.collectionAgentId, name: self.beneficiary.collectionAgent});
                    self.setCollectionPoint({id: self.beneficiary.collectionPointId, name: self.beneficiary.collectionPoint});
                }

                // (1 - BANK TRANFER && (13 - AUSTRALIA || 106 - JAPAN || 152 - NEW ZEALAND))
                //    || (3 - COLLECTION && (99 - INDONESIA || 167 - PHILIPPINES)) || 4 - DOOR TO DOOR
                if((this.deliveryMethodId == 1 && (this.homeCountryId == 13 || this.homeCountryId == 106 || this.homeCountryId == 152))
                    || (this.deliveryMethodId == 3 && (this.homeCountryId == 99 || this.homeCountryId == 167))
                    || this.deliveryMethodId == 4
                ) {
                    self.setCity({id: self.beneficiary.address.cityId, name: self.beneficiary.address.city});
                    self.setPostcode(self.beneficiary.address.postcode);
                    self.setProvince({id: self.beneficiary.address.provinceId, name: self.beneficiary.address.province});
                    if(self.homeCountryId == 152 && self.provinceId == 0) {
                        self.setProvince({id: 152000, name: ''});
                    }
                    self.setStreet(self.beneficiary.address.streetAddress);

                    // BANK TRANSFER && 106 - JAPAN
                    if(this.deliveryMethodId == 1 && this.homeCountryId == 106) {
                        self.setIsDropdown(true)
                    }else{
                        self.setIsDropdown(false)
                    }
                }else{
                    self.setPostcode("");
                    self.setProvince({id: 0, name: ""});
                }

                // 4 - DOOR TO DOOR || (1 - BANK TRANSFER && 106 - JAPAN)
                if(this.deliveryMethodId == 4 || (this.deliveryMethodId == 1 && this.homeCountryId == 106)) {
                    self.setLandmark(self.beneficiary.landmark);
                    self.setLocatingNote(self.beneficiary.locatingNote);
                }

                // (1 - BANK TRANFER && 205 - TAIWAN) || 3 - COLLECTION || 4 - DOOR TO DOOR
                if((this.deliveryMethodId == 1 && this.homeCountryId == 205) || this.deliveryMethodId == 3 || this.deliveryMethodId == 4) {
                    self.setIdentificationNo(self.beneficiary.identificationNo);

                    // 3 - COLLECTION || 4 - DOOR TO DOOR
                    if(this.deliveryMethodId == 3 || this.deliveryMethodId == 4) {
                        self.setIdentificationType(self.beneficiary.identificationType);
                    }
                }
                // NOT 0 - BILL PAYMENT
                if(this.deliveryMethodId != 0) {
                    self.setPaymentPurpose({id: self.beneficiary.paymentPurposeId, name: self.beneficiary.paymentPurpose});
                }

                // (0 - BILL PAYMENT && 167 - PHILIPPINES) || 3 - COLLECTION || 4 - DOOR TO DOOR
                if((this.deliveryMethodId == 0 && this.homeCountryId == 167) || this.deliveryMethodId == 3 || this.deliveryMethodId == 4) {
                    self.setRefNo(self.beneficiary.bankNotes);
                }

                self.setTransactionType({id: self.beneficiary.transactionTypeId, name: self.beneficiary.transactionType});

                if(self.deliveryMethodId == 1 && self.bankTypeId == 1) { // PHIL GOV
                    self.setDmExternalName(self.$t('general-text-dm-phil-gov'));
                    if(self.beneficiary.beneficiaryPhilGovLink) {
                        self.setPhilGovMemberType({id: self.beneficiary.beneficiaryPhilGovLink.memberTypeId, name: self.beneficiary.beneficiaryPhilGovLink.memberTypeName});
                    }
                } else if(self.deliveryMethodId == 1 && self.bankTypeId == 2) { // WALLET
                    self.setDmExternalName(self.$t('general-text-dm-7'));
                } else if(self.deliveryMethodId == 6 && self.homeCountryId == 18) { // BKASH
                    self.setDmExternalName(self.$t('general-text-dm-bkash'));
                } else {
                    self.setDmExternalName(self.$t('general-text-dm-' + self.deliveryMethodId));
                }

                this.loadForm();
                self.hidePreloader();
            },
            async changeBeneficiaryType_(txTypeId) {
                const self = this;
                var countryId       = this.homeCountryId;
                var beneTypeText =this.$t('beneficiary-other')
                if(txTypeId===1){
                    beneTypeText=this.$t('general-text-individual')
                }else{
                    beneTypeText=this.$t('general-text-corporate')
                }
                this.setBeneficiaryType({id: txTypeId, name: beneTypeText});
                let paymentPurposeListTmp = []
                if(this.transactionTypeId != 4 && this.transactionTypeId != 101) {
                    self.showPreloader();
                    let gender = store.state.customer.gender
                    if(gender.length<=0 || gender=== undefined){
                        gender ="M"
                    }
                    const purposePromise    = await this.$api.beneficiary.getPaymentPurposeList(countryId,gender, this.beneficiaryTypeId );
                    const ppList            = purposePromise

                    Object.keys(ppList).forEach(key => {
                        paymentPurposeListTmp.push({key: key, value: ppList[key]})
                    })

                    // NOT INDIA
                    if(this.homeCountryId != 98) {
                        paymentPurposeListTmp.push({key: -1, value: this.$t('beneficiary-other')})
                    }

                    self.setPaymentPurposeList(paymentPurposeListTmp);
                    self.setForceRerenderKey("paymentPurpose");
                    self.hidePreloader();

                }
                //console.log("test "+txTypeId)
            },

            // DR-1845 code-inspection fix (Minor) - extracted out of
            // loadBeneficiaryDetails() (which was already large pre-ticket and
            // shouldn't grow further without decomposition). Pre-populates
            // Beneficiary Country / Town-City from the beneficiary's stored
            // additionalFieldList (not returned by the beneficiary list, only by
            // the details call already loaded into self.beneficiary before this
            // runs). The saved value can be ANY country (not just this branch's
            // remittance corridors), so resolve its name against the complete
            // country list, not homeCountryList.
            async loadBeneficiaryAddress() {
                const self = this;
                await self.loadAllCountryList();
                await self.loadAddressConfig(self.beneficiary.homeCountryId);
                const additionalFieldList = self.beneficiary.additionalFieldList || [];
                const beneCountryField = additionalFieldList.find(f => f.fieldId == 39); // ADDITIONAL_FIELD_ID_BENEFICIARY_COUNTRY
                if(beneCountryField && beneCountryField.fieldValue) {
                    const beneCountryId = parseInt(beneCountryField.fieldValue);
                    const beneCountry   = self.allCountryList.find(c => c.id == beneCountryId);
                    self.setBeneficiaryCountry({id: beneCountryId, name: beneCountry ? beneCountry.name : ""});
                } else if(self.isAddressSectionInScope) {
                    // BUG FIX: previously defaulted unconditionally whenever nothing was
                    // saved, which silently populated Beneficiary Country even for
                    // corridors where this section is never shown (e.g. Indonesia) -
                    // reverted (d04e429a) for exactly that reason. Gated on
                    // isAddressSectionInScope (the single authoritative scope check this
                    // whole feature already uses) so it only defaults where the field
                    // actually applies.
                    const defaultCountry = self.allCountryList.find(c => c.id == self.beneficiary.homeCountryId);
                    self.setBeneficiaryCountry({id: self.beneficiary.homeCountryId, name: defaultCountry ? defaultCountry.name : ""});
                }
                const townCityField = additionalFieldList.find(f => f.fieldId == 37); // ADDITIONAL_FIELD_ID_BENEFICIARY_TOWNCITY
                if(townCityField && townCityField.fieldValue) {
                    self.setBeneficiaryTownCity(townCityField.fieldValue);
                }
            },
            async loadForm() {
                const self = this;
                self.showPreloader();

                // const branchPromise = await this.$api.beneficiary.getRetailBranchDetails();
                // const retailBranch  = branchPromise
                // var raId            = retailBranch.retailAgentId;
                var raId            = process.env.VUE_APP_RETAIL_AGENT_ID;

                if(self.beneficiaryTypeId > 0) {
                    this.changeBeneficiaryType(self.beneficiaryTypeId);
                }

                // 3 - COLLECTION
                self.setCollectionAgentList([]);
                if(this.deliveryMethodId == 3) {
                    const colAgentPromise    = await this.$api.beneficiary.getCollectionAgentList(raId, self.homeCountryId);
                    self.setCollectionAgentList(colAgentPromise);
                    self.setForceRerenderKey("collection");

                    const caList = Object.keys(self.collectionAgentList)
                    if(caList.length == 1) {
                        caList.forEach(key => {
                            self.setCollectionAgent({
                                id: key,
                                name: self.collectionAgentList[key]
                            })
                            this.setInputState("collectionAgent", true);
                        })
                    }
                    this.changeCollectionAgent(this.collectionAgentId);

                    // 18 - BANGLADESH || 98 - INDIA || 197 - SRI LANKA
                    if(this.homeCountryId == 18 || this.homeCountryId == 98 || this.homeCountryId == 197) {
                        const idTypePromise = await this.$api.beneficiary.getBeneficiaryIdType();
                        self.setIdTypeList(idTypePromise);

                        if(this.identificationType != '') {
                            Object.keys(self.idTypeList).forEach(key => {
                                if(self.idTypeList[key].toLowerCase() == self.identificationType.toLowerCase()) {
                                    self.setIdTypeSelect({id: key, name: self.idTypeList[key]});
                                }
                            })
                        }
                    }
                }

                // 4 - DOOR TO DOOR || (3 - COLLECTION && 167 - PHILIPPINES)
                // || 1 - BANK TRANSFER && (13 - AUSTRALIA || 106 JAPAN || 152 - NEW ZEALAND)
                self.setProvinceList([]);
                if(this.deliveryMethodId == 4 || (this.deliveryMethodId == 3 && this.homeCountryId == 167)
                    || (this.deliveryMethodId == 1 && (this.homeCountryId == 13 || this.homeCountryId == 106 || this.homeCountryId == 152))
                ) {
                    const provincePromise = await this.$api.beneficiary.getProvinceList(this.homeCountryId);
                    self.setProvinceList(provincePromise);

                    if (this.provinceId > 0) {
                        const cityPromise = await this.$api.beneficiary.getCityList(this.homeCountryId, this.provinceId);
                        self.setCityList(cityPromise);
                        self.setAllCityList(cityPromise);
                        self.setForceRerenderKey("suburb");
                    }

                    const oldCityId = this.cityId;
                    const oldCity = this.city;
                    this.changeProvince(this.provinceId);
                    this.setCity({id: oldCityId, name: oldCity});

                    if(oldCityId > 0){
                        const stPromise = await this.$api.beneficiary.getStreetListByCity(oldCityId);
                        self.setStreetList(stPromise);
                        self.setStreet(self.beneficiary.address.streetAddress);
                        self.setPostcode(self.beneficiary.address.postcode);
                    }
                }

                // NOT BILL PAYMENT && NOT PHIL GOV SERVICES
                let paymentPurposeListTmp = []
                if(self.deliveryMethodId > 0 && !(self.deliveryMethodId == 1 && self.bankTypeId == 1)) {
                    let gender = store.state.customer.gender
                    if(gender.length<=0 || gender=== undefined){
                        gender ="M"
                    }
                    let beneTypeId =self.beneficiary.beneficiaryTypeId
                    const purposePromise    = await this.$api.beneficiary.getPaymentPurposeList(this.homeCountryId, gender, beneTypeId);
                    const ppList            = purposePromise

                    Object.keys(ppList).forEach(key => {
                        paymentPurposeListTmp.push({key: key, value: ppList[key]})
                    })

                    // NOT INDIA
                    if(this.homeCountryId != 98) {
                        paymentPurposeListTmp.push({key: -1, value: this.$t('beneficiary-other')})
                    }

                    self.setPaymentPurposeList(paymentPurposeListTmp);
                    let ppIdTemp = 0;
                    let ppNameTemp = "";
                    if(this.paymentPurpose != '') {
                        for(let i=0; i < this.paymentPurposeList.length; i++) {
                            let thisPP = this.paymentPurposeList[i];
                            if(thisPP.value.toLowerCase() == this.paymentPurpose.toLowerCase()) {
                                //this.paymentPurposeId = thisPP.key;
                                ppIdTemp = thisPP.key;
                                ppNameTemp = thisPP.value;
                                break;
                            } else {
                                //this.paymentPurposeId = -1;
                                ppIdTemp = -1;
                                ppNameTemp = this.paymentPurpose;
                            }
                        }
                    }
                    self.setPaymentPurpose({id: ppIdTemp, name: ppNameTemp});

                    let $$ = this.Dom7;
                    if(this.paymentPurposeId == -1) {
                        $$('select[name="paymentPurpose"]').closest('li').addClass('mb-0');

                        self.setPaymentPurposeOther(ppNameTemp);
                        self.setPaymentPurpose({id: -1, name: this.$t('beneficiary-other')});
                    }

                    const params = {
                        ppId    : this.paymentPurposeId,
                        ppOther : this.paymentPurposeOther
                    }

                    this.displayPaymentPurposeOther(params)
                    this.setShowFormInputPaymentPurposeOther(store.state.beneficiary.isDisplayPaymentPurposeOther)
                }

                // 0 - BILL PAYMENT
                // self.setBillCorporationList([]);
                // if(this.deliveryMethodId == 0) {
                //     const billCorpListPromise = await this.$api.beneficiary.getBillCorporationList(self.homeCountryId);
                //     self.setBillCorporationList(billCorpListPromise)
                //     this.loadBillCorpList();
                // }

                // self.setCountryCodeList([]);
                // const countryPromise = await this.$api.beneficiary.getCountryPhoneCodeList();
                // self.setCountryCodeList(countryPromise)
                self.isShowPhone = true;

                this.changeHomePhoneCode(this.homeIDD)
                this.changeMobilePhoneCode(this.mobileIDD)
                self.hidePreloader();
            },

            init() {
                const self    = this;

                self.f7Method = {
                    confirmDialog: this.$f7.dialog.create({
                        title   : this.$t('beneficiary-remove-title'),
                        text    : this.$t('beneficiary-remove-notice'),
                        buttons : [
                            {text: this.$t('general-text-btn-cancel'), cssClass: 'confirm-no', onClick: this.closeConfirmDialog},
                            {text: this.$t('general-text-btn-delete'), cssClass: 'confirm-yes', onClick: this.deactivateRecipient},
                        ],
                        on      : {
                            open: function () {
                                self.$$('.dialog.dialog-buttons-2').prepend("<span class='close-button'><span>");
                            },
                            opened: function() {
                                self.$$('.dialog.dialog-buttons-2 .close-button').on('click', function () {
                                    self.closeConfirmDialog()
                                });
                            },
                            closed: function () {
                                self.$$('.dialog.dialog-buttons-2 .close-button').remove();
                            }
                        }
                    }),
                }
            },

            openConfirmDialog() {
                this.f7Method.confirmDialog.open();
            },

            closeConfirmDialog() {
                this.f7Method.confirmDialog.close();
            },

            loadBillCorpList() {
                const self         = this;
                const app          = self.$f7;
                const billCorpList = self.billCorporationList;

                // Simple Dropdown
                self.autocompleteBillCorpDropdownSimple = app.autocomplete.create({
                    inputEl: '#billCorp',
                    openIn : 'dropdown',
                    class  : '',
                    source : function(query, render) {
                        const results = [];
                        if(query.length <= 0) {
                            return;
                        }
                        if(query.length === 0) {
                            render(results);
                            return;
                        }
                        // Find Matched Items
                        Object.keys(billCorpList).forEach(key => {
                            if(billCorpList[key].toLowerCase().indexOf(query.toLowerCase()) >= 0) {
                                results.push(billCorpList[key]);
                            }
                        })

                        // Render Items By Passing Array With Result Items
                        render(results.sort());
                    }
                })
            },

            setInput(inputEl){
                this.setInputState(inputEl, this.validateInputState.value)
            },

            finalValidateBeforeSave() {
                let accountNumber = this.bankAccountNo
                const isWallet = (this.deliveryMethodId == 1 && this.bankTypeId == 2) ? true : false
                if(isWallet){
                    if(this.homeCountryId == 167){ // exclude countryIDD for PH (DR-1438)
                        accountNumber = this.walletNo
                    }else{
                        accountNumber = this.homeCountryIdd.substring(1) + this.walletNo
                    }
                }

                this.setIsFormInputValid(true);
                let params = {
                    countryId : this.homeCountryId,
                    txTypeId  : 0,
                    dmId      : this.deliveryMethodId,
                    bankId    : this.bankId,
                    bankTypeId: this.bankTypeId,
                    name      : this.beneficiaryName,
                    idType    : this.identificationType,
                    idNo      : this.identificationNo,
                    accountNo : accountNumber,//this.bankAccountNo,
                    provinceId: this.provinceId,
                    cityId    : this.cityId,
                    postcode  : this.postcode,
                    refNo     : this.refNo,
                    ppId      : this.paymentPurposeId,
                    ppOther   : this.paymentPurposeOther,
                    homeNo    : this.homeNo,
                    homeIDD   : this.homeIDD,
                    mobileNo  : this.mobileNo,
                    mobileIDD : this.mobileIDD,
                    email     : this.email,
                }

                let beneficiaryState = store.state.beneficiary

                // BENEFICIARY NAME
                this.validateBeneficiaryName(params);
                let fullNameField = this.transactionTypeId == 101 ? "philGovServiceFullname" : "beneficiaryName";
                this.setInputState(fullNameField, beneficiaryState.isValidBeneficiaryName);
                let isFormInputValidTmp = beneficiaryState.isValidBeneficiaryName == true ? true : false;
                this.setIsFormInputValid(isFormInputValidTmp);
                if(!isFormInputValidTmp) {
                    return;
                }

                // NICKNAME
                this.validateNickname(this.nickname);
                let nicknameField = this.transactionTypeId == 101 ? "philGovServiceNickname" : "nickname";
                this.setInputState(nicknameField, beneficiaryState.isValidNickname);
                this.setIsFormInputValid(beneficiaryState.isValidNickname == true ? true : false);
                if(!this.isFormInputValid) {
                    return;
                }

                // NOT DOOR TO DOOR && NOT COLLECTION
                if(this.deliveryMethodId != 4 && this.deliveryMethodId != 3) {
                    // ACCOUNT NUMBER
                    this.validateAccountNo(params);
                    this.setInputState("bankAccountNo", beneficiaryState.isValidAccountNo);
                    this.setIsFormInputValid(beneficiaryState.isValidAccountNo == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }
                }

                // NOT BILL PAYMENT && NOT PHIL GOV SERVICE
                if(this.deliveryMethodId != 0 && !(this.deliveryMethodId == 1 && this.bankTypeId == 1)) {
                    // PURPOSE OF PAYMENT
                    let purposeField = this.paymentPurposeId == -1 ? "paymentPurposeOther" : "paymentPurpose";
                    Object.assign(params, {purposeField: purposeField});
                    this.finalValidatePaymentPurpose(params);
                    this.setInputState(purposeField, beneficiaryState.isValidPaymentPurpose);
                    this.setIsFormInputValid(beneficiaryState.isValidPaymentPurpose == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }
                }

                // NOT PHIL GOV SERVICE
                if(!(this.deliveryMethodId == 1 && this.bankTypeId == 1)) {
                    // HOME NUMBER
                    this.finalValidateHomePhone(params);
                    this.setInputState("homeNo", beneficiaryState.isValidHomeNo);
                    this.setIsFormInputValid(beneficiaryState.isValidHomeNo == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }

                    // MOBILE NUMBER
                    this.finalValidateMobilePhone(params);
                    this.setInputState("mobileNo", beneficiaryState.isValidMobileNo);
                    this.setIsFormInputValid(beneficiaryState.isValidMobileNo == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }
                }

                // EMAIL
                this.validateEmail(params);
                this.setInputState("email", beneficiaryState.isValidEmail);
                this.setIsFormInputValid(beneficiaryState.isValidEmail == true ? true : false);
                if(!this.isFormInputValid) {
                    return;
                }

                // 1 - BANK TRANSFER || 6 - CASH CARD
                if(this.deliveryMethodId == 1 || this.deliveryMethodId == 6) {
                    // 1 - BANK TRANSFER
                    if(this.deliveryMethodId == 1) {
                        // PHIL GOV SERVICES
                        if(this.bankTypeId == 1) {
                            // PHIL GOV MEMBER TYPE
                            this.validatePhilGovMemberType(this.philGovMemberTypeId);
                            this.setInputState("philGovMemberType",  beneficiaryState.isValidPhilGovMemberType);
                            this.setIsFormInputValid(beneficiaryState.isValidPhilGovMemberType == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }
                        }
                        // 44 - CHINA
                        else if(this.homeCountryId == 44) {
                            // INDENTIFICATION NUMBER
                            this.validateIdentificationNo(params);
                            this.setInputState("cnIdentificationNo", beneficiaryState.isValidIdNo);
                            this.setIsFormInputValid(beneficiaryState.isValidIdNo == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // DATE OF BIRTH
                            this.validateDOB(this.dateOfBirth);
                            this.setInputState("dateOfBirth", beneficiaryState.isValidDateOfBirth);
                            this.setIsFormInputValid(beneficiaryState.isValidDateOfBirth == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }
                        }
                        // 13 - AUSTRALIA || 152 - NEW ZEALAND
                        else if(this.homeCountryId == 13 || this.homeCountryId == 152) {
                            // BSB CODE
                            const params = {bsbCode : this.bsbCode, countryId: this.homeCountryId}
                            this.validateBsbCode(params);
                            this.setInputState("bsbCode", beneficiaryState.isValidBsbcode);
                            this.setIsFormInputValid(beneficiaryState.isValidBsbcode == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // ADDRESS
                            this.validateStreet(this.street);
                            this.setInputState("address", beneficiaryState.isValidStreet);
                            this.setIsFormInputValid(beneficiaryState.isValidStreet == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // POSTCODE
                            Object.assign(params, {postcodeField: "kaasiPostcode"});
                            this.finalValidatePostcode(params)
                            setTimeout(() => {
                                this.setIsFormInputValid(beneficiaryState.isValidPostcode.inputState == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }
                            }, 2000)

                            // SUBURB
                            this.validateCity(this.cityId);
                            this.setInputState("suburb", beneficiaryState.isValidCity);
                            this.setIsFormInputValid(beneficiaryState.isValidCity == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // RECEIVER TYPE
                            this.validateBeneficiaryType(this.beneficiaryTypeId);
                            let radioErrorMsgTmp2     = beneficiaryState.isValidBeneficiaryType == true ? "" : beneficiaryState.isValidBeneficiaryType
                            this.setRadioErrorMsg(radioErrorMsgTmp2);
                            let tmpIsDisplayErrorMsg2 = beneficiaryState.isValidBeneficiaryType == true ? false : true
                            this.setIsDisplayErrorMsg(tmpIsDisplayErrorMsg2)
                            this.setInputState("beneficiaryType", beneficiaryState.isValidBeneficiaryType);
                            this.setIsFormInputValid(beneficiaryState.isValidBeneficiaryType == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // 13 - AUSTRALIA
                            if(this.homeCountryId == 13) {
                                // STATE
                                this.validateProvince(this.provinceId);
                                this.setInputState("state", beneficiaryState.isValidProvince);
                                this.setIsFormInputValid(beneficiaryState.isValidProvince == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }

                                // 2 - BUSINESS
                                if(this.beneficiaryTypeId == 2) {
                                    // ABN
                                    this.validateAbn(this.audAbn);
                                    this.setInputState( "audAbn", beneficiaryState.isValidAbn);
                                    this.setIsFormInputValid(beneficiaryState.isValidAbn == true ? true : false);
                                    if(!this.isFormInputValid) {
                                        return;
                                    }

                                    // ACN
                                    this.validateAcn(this.audAcn);
                                    this.setInputState("audAcn", beneficiaryState.isValidAcn);
                                    this.setIsFormInputValid(beneficiaryState.isValidAcn == true ? true : false);
                                    if(!this.isFormInputValid) {
                                        return;
                                    }
                                }
                            }
                            // 152 - NEW ZEALAND
                            else if(this.homeCountryId == 152) {
                                // 2 - BUSINESS
                                if(this.beneficiaryTypeId == 2) {
                                    // NZBN
                                    this.validateNzbn(this.nzbn);
                                    this.setInputState("nzbn", beneficiaryState.isValidNzbn);
                                    this.setIsFormInputValid(beneficiaryState.isValidNzbn == true ? true : false);
                                    if(!this.isFormInputValid) {
                                        return;
                                    }
                                }
                            }
                        }
                        // 98 - INDIA
                        else if(this.homeCountryId == 98) {
                            // BENEFICIARY TYPE
                            this.validateBeneficiaryType(this.beneficiaryTypeId);
                            this.setInputState("beneficiaryType", beneficiaryState.isValidBeneficiaryType);
                            this.setIsFormInputValid(beneficiaryState.isValidBeneficiaryType == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // // IFSC CODE
                            // this.validateIfscCode(this.ifscCode);
                            // this.setInputState("ifscCode", beneficiaryState.isValidIfsccode);
                            // this.setIsFormInputValid(beneficiaryState.isValidIfsccode == true ? true : false);
                            // if(!this.isFormInputValid) {
                            //     return;
                            // }
                        }
                        // 106 - JAPAN
                        else if(this.homeCountryId == 106){
                            // PROVINCE
                            this.validateProvince(this.provinceId);
                            this.setInputState("province", beneficiaryState.isValidProvince);
                            this.setIsFormInputValid(beneficiaryState.isValidProvince == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // CITY || DISTRICT
                            this.validateCity(this.cityId);
                            this.setInputState("city", beneficiaryState.isValidCity);
                            this.setIsFormInputValid(beneficiaryState.isValidCity == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // STREET
                            this.validateStreet(this.street);
                            //console.log("result validation street : "+beneficiaryState.isValidStreet)
                            this.setInputState("streetDropdown", beneficiaryState.isValidStreet);
                            this.setIsFormInputValid(beneficiaryState.isValidStreet == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // POSTCODE
                            Object.assign(params, {postcodeField: "postcode"});
                            this.finalValidatePostcode(params)
                            this.setIsFormInputValid(beneficiaryState.isValidPostcode.inputState == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // LANDMARK
                            this.validateLandmark(this.landmark);
                            this.setInputState("landmark", beneficiaryState.isValidLandmark);
                            this.setIsFormInputValid(beneficiaryState.isValidLandmark == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }
                        }
                        // 205 - TAIWAN
                        else if(this.homeCountryId == 205) {
                            // IDENTIFICATION NUMBER
                            this.validateIdentificationNo(params);
                            this.setInputState("identificationNo", beneficiaryState.isValidIdNo);
                            this.setIsFormInputValid(beneficiaryState.isValidIdNo == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }
                        }
                        // 221 - UNITED KINGDOM || 238 - EUROPEAN UNION (EU)
                        else if(this.homeCountryId == 221 || this.homeCountryId == 238) {
                            // IBAN
                            this.validateIban(this.iban);
                            this.setInputState("iban", beneficiaryState.isValidIban);
                            this.setIsFormInputValid(beneficiaryState.isValidIban == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // 221 - UNITED KINGDOM
                            if(this.homeCountryId == 221) {
                                // SORT CODE
                                this.validateSortCode(this.sortCode);
                                this.setInputState("sortCode", beneficiaryState.isValidSortcode);
                                this.setIsFormInputValid(beneficiaryState.isValidSortcode == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }
                            }
                            // 238 - EUROPEAN UNION (EU)
                            else if(this.homeCountryId == 238) {
                                // SWIFT CODE
                                this.validateSwiftCode(this.swiftCode);
                                this.setInputState("swiftCode", beneficiaryState.isValidSwiftcode);
                                this.setIsFormInputValid(beneficiaryState.isValidSwiftcode == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }
                            }
                        }
                        // 253 - AMERICA
                        else if(this.homeCountryId == 253) {
                            // SWIFT CODE
                            this.validateSwiftCode(this.swiftCode);
                            this.setInputState("swiftCode", beneficiaryState.isValidSwiftcode);
                            this.setIsFormInputValid(beneficiaryState.isValidSwiftcode == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }
                        }
                    }
                }
                // 4 - DOOR TO DOOR || 3 - COLLECTION
                else if(this.deliveryMethodId == 4 || this.deliveryMethodId == 3) {
                    // IDENTIFICATION TYPE
                    // 3 - COLLECTION && (18 - BANGLADESH || 98 - INDIA || 197 - SRI LANKA (SELECT), OTHER TEXT)
                    if(this.deliveryMethodId == 3
                            && (this.homeCountryId == 18 || this.homeCountryId == 98 || this.homeCountryId == 197)
                    ) {
                        this.validateIdTypeSelect(this.idTypeSelectId);
                        this.setInputState("idTypeSelect", beneficiaryState.isValidIdTypeSelect);
                        this.setIsFormInputValid(beneficiaryState.isValidIdTypeSelect == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    } else {
                        this.validateIdentificationType(params);
                        this.setInputState("identificationType", beneficiaryState.isValidIdType);
                        this.setIsFormInputValid(beneficiaryState.isValidIdType == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    }

                    // IDENTIFICATION NUMBER
                    this.validateIdentificationNo(params);
                    this.setInputState("identificationNo", beneficiaryState.isValidIdNo);
                    this.setIsFormInputValid(beneficiaryState.isValidIdNo == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }

                    // REF NO
                    this.validateRefNote(params);
                    this.setInputState("refNo", beneficiaryState.isValidRefNo);
                    this.setIsFormInputValid(beneficiaryState.isValidRefNo == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }

                    // 4 - DOOR TO DOOR || (3 - COLLECTION && (167 - PHILIPPINES && (1104 - BDO/RURAL BANK/SM FOREX || 2200 - PALAWAN PAWNSHOP))
                    if(this.deliveryMethodId == 4
                        || (this.deliveryMethodId == 3 && (this.homeCountryId == 167 && (this.collectionAgentId == 1104 || this.collectionAgentId == 2200)))
                    ) {
                        // PROVINCE
                        this.validateProvince(this.provinceId);
                        this.setInputState("province", beneficiaryState.isValidProvince);
                        this.setIsFormInputValid(beneficiaryState.isValidProvince == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }

                        // CITY
                        this.validateCity(this.cityId);
                        this.setInputState("city", beneficiaryState.isValidCity);
                        this.setIsFormInputValid(beneficiaryState.isValidCity == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }

                        // POSTCODE
                        Object.assign(params, {postcodeField: "postcode"});
                        this.finalValidatePostcode(params)
                        this.setIsFormInputValid(beneficiaryState.isValidPostcode.inputState == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    }

                    // 4 - DOOR TO DOOR || (3 - COLLECTION && (99 - INDONESIA || (167 - PHILIPPINES && (1104 - BDO/RURAL BANK/SM FOREX || 2200 - PALAWAN PAWNSHOP)))
                    if(this.deliveryMethodId == 4
                        || (this.deliveryMethodId == 3
                                && (this.homeCountryId == 99 || (this.homeCountryId == 167 && (this.collectionAgentId == 1104 || this.collectionAgentId == 2200)))
                            )
                    ) {
                        // STREET
                        this.validateStreet(this.street);
                        this.setInputState("street", beneficiaryState.isValidStreet);
                        this.setIsFormInputValid(beneficiaryState.isValidStreet == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    }

                    // 3 - COLLECTION
                    if(this.deliveryMethodId == 3) {
                        // COLLECTION AGENT
                        this.validateCollectionAgent(this.collectionAgentId);
                        this.setInputState("collectionAgent", beneficiaryState.isValidCollectionAgent);
                        this.setIsFormInputValid(beneficiaryState.isValidCollectionAgent == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }

                        // COLLECTION POINT
                        this.validateCollectionPoint(this.collectionPointId);
                        this.setInputState("collectionPoint", beneficiaryState.isValidCollectionPoint);
                        this.setIsFormInputValid(beneficiaryState.isValidCollectionPoint == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    }
                }
                // 0 - BILL PAYMENT
                else if(this.deliveryMethodId == 0) {
                    // BILL CORPORATION
                    this.validateBillCorp(this.billCorporationId);
                    this.setInputState("billCorp", beneficiaryState.isValidBillCorp);
                    this.setIsFormInputValid(beneficiaryState.isValidBillCorp == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }

                    // 167 - PHILIPPINES && REF NO
                    if(this.homeCountryId == 167) {
                        // REF NO
                        this.validateRefNote(params);
                        this.setInputState("refNo", beneficiaryState.isValidRefNo);
                        this.setIsFormInputValid(beneficiaryState.isValidRefNo == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    }
                }
                // 9 - UPI
                else if(this.deliveryMethodId == 9) {
                    // BENEFICIARY TYPE
                    this.validateBeneficiaryType(this.beneficiaryTypeId);
                    this.setInputState("beneficiaryType", beneficiaryState.isValidBeneficiaryType);
                    this.setIsFormInputValid(beneficiaryState.isValidBeneficiaryType == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }
                }

                // DR-1845 - BENEFICIARY COUNTRY / TOWN-CITY (only blocks when hard
                // mandatory for this destination country; soft/optional otherwise).
                // Both are validated together (rather than stopping at the first
                // invalid one) so the hard-required popup below can cover "country
                // and city" collectively, matching its wording - same combined
                // treatment retail uses for its own soft-mode message.
                this.validateBeneficiaryCountry(this.beneficiaryCountryId);
                this.setInputState("beneficiaryCountryId", beneficiaryState.isValidBeneficiaryCountry);

                this.validateBeneficiaryTownCity(this.beneficiaryTownCity);
                this.setInputState("beneficiaryTownCity", beneficiaryState.isValidBeneficiaryTownCity);

                this.setIsFormInputValid(beneficiaryState.isValidBeneficiaryCountry == true
                    && beneficiaryState.isValidBeneficiaryTownCity == true);
                if(!this.isFormInputValid) {
                    this.showAddressRequiredAlert();
                    return;
                }

                return this.isFormInputValid;
            },

            // DR-1845 code-inspection fix (Major) - showAddressRequiredAlert() and
            // confirmProceedWithoutAddress() moved to plugins/address-dialog-mixin.js
            // (mixed in above) - were duplicated verbatim here and in
            // new-beneficiary-details.vue.

            validateDAChoice(value) {
                if(value == 2) { // yes
                    this.setBeneficiaryName(this.daValidation.proposedResult);
                } else {
                    this.daValidation.skipValidation = true;
                }
                this.daValidation.showSheet = false;
                this.modifyRecipient();
            },

            async modifyRecipient() {
                this.showPreloader();
                this.showAlert(false);
                if(!this.finalValidateBeforeSave()) {
                    this.hidePreloader();
                    return;
                }

                // DR-1845 - soft-mandatory mode: the global toggle is off, so
                // finalValidateBeforeSave() above never blocks on a blank
                // Beneficiary Country/Town-City even when this destination wants
                // it - confirm with the customer/agent before proceeding, same as
                // retail's CreateRemittance.jsp doSubmit() confirm() popup.
                this.hidePreloader();
                if(!(await this.confirmProceedWithoutAddress())) {
                    return;
                }
                this.showPreloader();

                const beneficiaryData = store.state.beneficiary;

                // WS validation
                const validateInput = await this.$api.beneficiary.validateBeneInput(beneficiaryData, false);
                if(validateInput.invalid) {
                    this.showAlert("true", validateInput.errTitle);
                    this.setInputState(validateInput.inputField, this.$t(validateInput.errMsg, { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                    this.setIsFormInputValid(false);

                    this.hidePreloader();
                    return;
                } else if(!validateInput.result.isValid && validateInput.result.daResultCode == 1758 && !this.daValidation.skipValidation) {
                    this.daValidation.showSheet = true;
                    this.daValidation.proposedResult = validateInput.result.proposedResult;

                    var $$ = this.Dom7;
                    $$("#currentValue").text(this.beneficiaryName);
                    $$("#proposedValue").text(this.daValidation.proposedResult);
                    // $$("#daTitleLbl").text(this.$t(validateInput.result.message));
                    $$("#daDescLbl").text(this.$t(validateInput.result.message + "-desc"));

                    this.hidePreloader();
                    return;
                }

                // WS validation success then modify bene
                if(!validateInput.invalid) {
                    this.showPreloader();
                    const modifyBeneficiary = await this.$api.beneficiary.modifyBeneficiary(beneficiaryData);

                    if(modifyBeneficiary.invalid) {
                        this.showAlert(true, this.$t(modifyBeneficiary.message));
                    } else if(modifyBeneficiary.status == '0415') {// success
                        beneficiaryData.routerTo = "beneficiaryModified"
                        this.resetDataStore({isNewHomeCountry: true});
                        this.$f7router.navigate("/beneficiary-list");
                    } else {
                        this.showAlert(true, this.$t('beneficiary-ws-general-error'));
                    }
                }
                this.hidePreloader();
            },

            async deactivateRecipient() {
                this.showPreloader();
                this.showAlert(false);

                var beneData             = store.state.beneficiary;
                beneData.beneficiaryName = this.beneficiary.fullName;

                const deactivateBeneficiary = await this.$api.beneficiary.deleteBeneficiary(this.beneficiaryId);
                if(deactivateBeneficiary.invalid) {
                    this.showAlert("true", deactivateBeneficiary.errTitle, deactivateBeneficiary.errMsg);
                    this.hidePreloader()
                    return;
                } else if(deactivateBeneficiary.status == '0409') { // success
                    beneData.routerTo = "beneficiaryDeleted"
                    this.resetDataStore({isNewHomeCountry: true});
                    this.$f7router.navigate("/beneficiary-list");
                } else {
                    this.showAlert(true, this.$t('beneficiary-ws-general-error'));
                }
                this.hidePreloader();
            },

            showAlert(status, title, content) {
                this.alertCard.show = status;
                if(title == undefined) {
                    title = "";
                } else {
                    title = this.$t(title);
                }

                if(content == undefined) {
                    content = "";
                } else {
                    content = this.$t(content);
                }
                this.alertCard.title   = title;
                this.alertCard.content = content;
            },

            backButton() {
                this.showAlert(false);
                this.resetFormData();
                this.resetDataStore({isNewHomeCountry: true});
                this.$f7router.back({ transition: 'f7-push' })
            }
        }
    }
</script>